import './ExclusiveSkuCTA.scss'

import { ReactComponent as ChevronRight } from 'src/assets/icons/chevron-right.svg'
import { useExclusiveSKUMeal } from 'src/hooks/useExclusiveSKUMeal'
import { Meal } from 'src/types/meal'

interface ExclusiveSkuCTAProps {
  meal: Meal
}

export const ExclusiveSkuCTA = ({ meal }: ExclusiveSkuCTAProps) => {
  const { data, handleClick } = useExclusiveSKUMeal({
    mealId: meal.id,
    mealName: meal.name,
    isExclusiveMembershipProduct: meal.isExclusiveMembershipProduct ?? false
  })

  return (
    <button className="exclusive-sku-card-action" onClick={handleClick}>
      <div className="exclusive-sku-card-action__content">
        <div className="exclusive-sku-card-action__title">{data?.title}</div>
        <div className="exclusive-sku-card-action__description">
          {data?.description}
        </div>
      </div>
      <div className="exclusive-sku-card-action__icon">
        <ChevronRight />
      </div>
    </button>
  )
}
